var _excluded = ["className", "id", "src", "srcAlt", "size", "type", "isAnimated", "aria-labelledby", "utils"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import generateId from '../../utilities/generateID';
import StyledVehicleImage from './vehicle-image.styles';
import StyledVehicleImageContainer from './styles/vehicle-image-container.styles';
import Suv from './images/Suv';
import MidSize from './images/MidSize';
import { createDefs } from './images/utils';
import withDeprecatedProps from '../../utilities/with-deprecated-props/withDeprecatedProps';
var vehicleImagePropTypes = {
  /** For accessibility, allows aria-labelledby to be spread onto the placeholder SVG or Image if provided  */
  'aria-labelledby': PropTypes.string,
  /**
   * @deprecated since 2.56.0
   * @see aria-labelledby
   */
  ariaLabelledby: PropTypes.string,
  /** Additional className to be added to the vehicleImage's classlist */
  className: PropTypes.string,
  /** ID of the VehicleImage */
  id: PropTypes.string,
  /** Vehicle type, displays placeholder image, if no image url is provided */
  type: PropTypes.oneOf(['suv', 'midSize', 'truck', 'crossover', 'mpv', 'compact', '']),
  /** Image URL */
  src: PropTypes.node,
  /** Alt text of the image or SVG title. */
  srcAlt: PropTypes.string,
  /** Size of image */
  size: PropTypes.oneOf(['xs', 'sm', 'md', 'lg']),
  /** Add any of our css utilities to this component */
  utils: PropTypes.object,
  /** Adds fade-in effect */
  isAnimated: PropTypes.bool
};
var vehicleImageDefaultProps = {
  className: '',
  id: '',
  type: 'suv',
  src: '',
  srcAlt: '',
  size: 'md',
  utils: {},
  isAnimated: true,
  'aria-labelledby': null,
  ariaLabelledby: null
};
var setSrcAlt = function setSrcAlt(srcAlt, defaultSrcAlt) {
  return srcAlt ? srcAlt : defaultSrcAlt;
};

// Display placeholder SVG, based on type.
var displaySVG = function displaySVG(type, srcAlt, ariaLabelledby, id) {
  var useId = id || generateId('vehicle_');
  var svgTitle = '';
  var svgVehicle = '';
  if (type === 'suv' || type === 'truck' || type === 'crossover' || type === '') {
    svgTitle = 'SUV';
    svgVehicle = /*#__PURE__*/React.createElement(Suv, {
      useId: useId,
      type: "suv",
      transform: "translate(37 313)"
    });
  } else if (type === 'midSize' || type === 'mpv' || type === 'compact') {
    svgTitle = 'Midsize';
    svgVehicle = /*#__PURE__*/React.createElement(MidSize, {
      useId: useId,
      type: "midSize",
      transform: "translate(50 307.9)"
    });
  }
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "69",
    viewBox: "0 0 640 480",
    role: "img",
    "aria-labelledby": ariaLabelledby !== '' ? ariaLabelledby : null
  }, /*#__PURE__*/React.createElement("title", null, setSrcAlt(srcAlt, svgTitle)), createDefs(useId), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h640v480H0z"
  }), svgVehicle));
};

/**
 * @ignore @description
 * ## VehicleImage
 * The VehicleImage component can provide a placeholder image for vehicles or can display an image, if URL is entered.
 *
 * @ignore @see Mesh: [VehicleImage Docs](https://mesh-component-library.apps.csts-k8cnp-ro-1.r-caas.allstate.com/?path=/story/visual-elements-vehicleimage--default)
 *
 * @ignore @example
 * ```jsx
 * import { VehicleImage } from 'mesh-component-library';
 *
 * <VehicleImage />;
 * ```
 */

export var VehicleImage = function VehicleImage(props) {
  var className = props.className,
    id = props.id,
    src = props.src,
    srcAlt = props.srcAlt,
    size = props.size,
    type = props.type,
    isAnimated = props.isAnimated,
    ariaLabelledby = props['aria-labelledby'],
    utils = props.utils,
    other = _objectWithoutProperties(props, _excluded);
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isLoaded = _React$useState2[0],
    setIsLoaded = _React$useState2[1];
  var _React$useState3 = React.useState(false),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    hasError = _React$useState4[0],
    setHasError = _React$useState4[1];
  var _React$useState5 = React.useState(),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    srcState = _React$useState6[0],
    setSrc = _React$useState6[1];
  var preloadImage = function preloadImage() {
    setIsLoaded(false);
    setHasError(false);
    var img = new Image();
    img.src = src;
    img.onerror = function () {
      setIsLoaded(true);
      setHasError(true);
    };
    img.onload = function () {
      setIsLoaded(true);
    };
  };
  useEffect(function () {
    if (src == srcState) return;
    setSrc(src);
    preloadImage();
  }, [src]);
  if (src === null) {
    return null;
  }
  return /*#__PURE__*/React.createElement(StyledVehicleImage, _extends({
    className: className,
    size: size,
    utils: utils,
    src: src,
    isLoaded: isLoaded,
    isAnimated: isAnimated
  }, other), /*#__PURE__*/React.createElement(StyledVehicleImageContainer, {
    size: size,
    isAnimated: isAnimated
  }, /*#__PURE__*/React.createElement("canvas", {
    width: 69,
    height: 51.75
  }), src && isLoaded && !hasError ? /*#__PURE__*/React.createElement("img", {
    src: src,
    alt: srcAlt,
    width: "69",
    "aria-labelledby": ariaLabelledby !== '' ? ariaLabelledby : null
  }) : displaySVG(type, srcAlt, ariaLabelledby, id)));
};
VehicleImage.propTypes = vehicleImagePropTypes;
VehicleImage.defaultProps = vehicleImageDefaultProps;
VehicleImage.displayName = 'VehicleImage';
/**
 * @type React.FC<vehicleImagePropTypes>
 */
export default withDeprecatedProps(VehicleImage);